import { app } from '../../app.module'
app
  // 投稿テーブルアクション
  .directive('postTableActions', () => {
    return {
      restrict: 'EA',
      template: require('./post-table-actions.pug')(),
      controller: function ($scope, $attrs) {
        // 投稿タグ管理モーダルに渡すため、SNSの種類をattrsから取得
        $scope.snsType = $attrs.snsType
      },
    }
  })
